<template>
  <el-dialog
    title="Delivery Address"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    :append-to-body="true"
    width="650px"
    @closed="resetValidation"
    class="address-dialog"
  >
    <ValidationObserver ref="observer" tag="form" @submit.prevent="submit">
      <mdb-row>
        <mdb-col col="12">
          <ThatsInput
            labelClass="col-md-3"
            fieldClass="col-md-9 pl-0"
            label="Address"
            vid="address"
            name="address"
            v-model="formDataProps.attr.address"
            :validated="validated"
            size="sm"
          />
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col col="3" offset="3">
          <ThatsInput
            labelClass="col-md-4 pl-0 pr-0"
            fieldClass="col-md-8 pl-0"
            label="Bldg"
            vid="building"
            name="building"
            v-model="formDataProps.attr.address2.building"
            :validated="validated"
            size="sm"
          />
        </mdb-col>
        <mdb-col col="3">
          <ThatsInput
            labelClass="col-md-4 pl-0 pr-0"
            fieldClass="col-md-8 pl-0"
            label="Street"
            vid="street"
            name="street"
            v-model="formDataProps.attr.address2.street"
            :validated="validated"
            size="sm"
          />
        </mdb-col>
        <mdb-col col="3">
          <ThatsInput
            labelClass="col-md-4 pl-0 pr-0"
            fieldClass="col-md-8 pl-0"
            label="Zone"
            vid="zone"
            name="zone"
            v-model="formDataProps.attr.address2.zone"
            :validated="validated"
            size="sm"
          />
        </mdb-col>
      </mdb-row>

      <mdb-row>
        <mdb-col col="12">
          <ThatsInput
            labelClass="col-md-3"
            fieldClass="col-md-9 pl-0"
            label="Area"
            vid="area"
            name="area"
            v-model="formDataProps.attr.address2.area"
            :validated="validated"
            :rules="'required'"
            size="sm"
          />
        </mdb-col>
      </mdb-row>

      <mdb-row>
        <mdb-col col="12">
          <ThatsMultiSelect
            :multiple="false"
            :clearable="false"
            labelClass="col-md-3"
            fieldClass="col-md-9 pl-0"
            label="City"
            v-model="formDataProps.attr.address2.city"
            :reduce="label => label.code"
            :reduceLabel="'label'"
            :options="cities"
            :rules="'required'"
          />
        </mdb-col>
      </mdb-row>
    </ValidationObserver>

    <template slot="footer">
      <mdb-btn color="grey" size="sm" @click.native="closeDialog">Cancel</mdb-btn>
      <mdb-btn color="elegant" size="sm" @click.native="submit">Apply</mdb-btn>
    </template>
  </el-dialog>
</template>

<script>
import { mdbBtn, mdbRow, mdbCol } from 'mdbvue';
import { ValidationObserver } from 'vee-validate';
import { ThatsInput, ThatsMultiSelect } from '../../thats/Thats';

export default {
  name: 'AddressDialog',

  components: {
    ValidationObserver,
    ThatsInput,
    ThatsMultiSelect,
    mdbBtn,
    mdbRow,
    mdbCol
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    formDataProps: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      validated: false,
      localVisible: false,
      cities: [
        { label: 'Doha', code: 'Doha' },
        { label: 'Al-Rayyan', code: 'Al-Rayyan' },
        { label: 'Al Khor', code: 'Al Khor' },
        { label: 'Al Wakrah', code: 'Al Wakrah' },
        { label: 'Umm-Salal', code: 'Umm-Salal' },
        { label: 'Al-Dayian', code: 'Al-Dayian' },
        { label: 'Ash-Shamal', code: 'Ash-Shamal' }
      ]
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.value || this.localVisible;
      },
      set(value) {
        this.localVisible = value;
        this.$emit('input', value);
      }
    }
  },

  created() {
    this.ensureAddressFields();
  },

  methods: {
    ensureAddressFields() {
      if (!this.formDataProps.attr) {
        this.$set(this.formDataProps, 'attr', {});
      }

      if (!this.formDataProps.attr.address2) {
        this.$set(this.formDataProps.attr, 'address2', {});
      }

      ['address', 'building', 'street', 'zone', 'area', 'city'].forEach((field) => {
        if (field === 'address') {
          if (this.formDataProps.attr[field] === undefined) {
            this.$set(this.formDataProps.attr, field, null);
          }
          return;
        }

        if (this.formDataProps.attr.address2[field] === undefined) {
          this.$set(this.formDataProps.attr.address2, field, null);
        }
      });
    },

    openDialog() {
      this.ensureAddressFields();
      this.localVisible = true;
    },

    closeDialog() {
      this.localVisible = false;
      this.$emit('input', false);
    },

    submit() {
      this.validated = true;

      Promise.resolve(this.$refs.observer.validate()).then((isValid) => {
        if (!isValid) {
          return;
        }

        this.$emit('update', this.formDataProps);
        this.closeDialog();
      });
    },

    resetValidation() {
      this.validated = false;

      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }
    }
  }
};
</script>
